import Big from 'big.js';

/**
 * big.js
 * github: https://github.com/MikeMcl/big.js
 * docs: http://mikemcl.github.io/big.js/
 * 给Number原型对象增加更稳定可靠的加减乘除计算方法
 */

export default {
  install() {
    const toNumber = (num: any) => new Big(Number(num));
    Number.prototype.a = function(...nums: Array<any>): number {
      return Number(
        nums
          .reduce((a: any, b: any) => {
            if (Object.prototype.toString.call(b) == '[object Array]') {
              return b.reduce((c: any, d: number) => c.plus(toNumber(d)), a);
            }
            return a.plus(toNumber(b));
          }, new Big(this))
          .toFixed()
      );
    };
    Number.prototype.b = function(num: number): number {
      return Number(new Big(this || 0).minus(toNumber(num)).toFixed());
    };
    Number.prototype.c = function(num: number): number {
      return Number(new Big(this || 0).times(toNumber(num)).toFixed());
    };
    Number.prototype.d = function(num: number): number {
      if (toNumber(num).toString() == 0) return 0;
      return Number(new Big(this || 0).div(toNumber(num)).toFixed());
    };
    Number.prototype.mod = function(num: number): number {
      return Number(new Big(this || 0).mod(toNumber(num)).toFixed());
    };
    Number.prototype.pow = function(num: number): number {
      return Number(new Big(this || 0).pow(toNumber(num)).toFixed());
    };
    Number.prototype.sqrt = function(num: number): number {
      return Number(new Big(this || 0).sqrt(toNumber(num)).toFixed());
    };
    Number.prototype.toFixed = function(fractionDigits: number = 0): string {
      let ary: string[] =
        String(this)
          .replace(/[^-\d.]/g, '')
          .match(/[-]?\d+/g) || [];
      ary[0] = ary[0] || '0';
      ary[1] = ary[1] || '0';
      while (fractionDigits > 0 && ary[1].length < fractionDigits) {
        ary[1] = ary[1] + '0';
      }
      if (fractionDigits <= 0) return ary[0];
      return ary[0] + '.' + ary[1].substr(0, fractionDigits);
      /* const num: number = Math.floor(Number(this) * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits);
			const ary: Array<string> = String(num).split('.');
			let decimal: Array<string> = (ary[1] || '').split('');
			while (decimal.length < fractionDigits) {
				decimal.push('0');
			}
			decimal = decimal.slice(0, fractionDigits);
			if (decimal.length) {
				ary[1] = decimal.join('');
			}
			return ary.join('.'); */
    };
  }
};
